// import { httpService } from '@/services/HttpService'
import axios from 'axios'

const state = ({
  currentCouriers: [],
})

const getters = {
  //
}

const actions = {
  getCurrentCouriers ({ commit, rootGetters }, data) {
    return axios
      .get(`${rootGetters['api/fetchCouriersCurrentGeoPositions']}`, {
        params: data,
      })
      .then(res => {
        try {
          commit('setCurrentCouriers', res.data.data)
          return res.data.data
        } catch (err) {
          throw new Error(err)
        }
      })
      .catch(err => {
        throw new Error(err)
      })
    // return httpService.get('/couriers/geo/current', params)
  },
}

const mutations = {
  setCurrentCouriers (state, value) {
    state.currentCouriers = value
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
